<template>
  <div class="home">
    <!-- <div class="row">
      <div class="col-md-7">
        <div class="card bg-dark p-4">
          <LineChartComponent v-if="reports.orders_daily" :chart-data="reports.orders_daily" :options="options"></LineChartComponent>
        </div>
      </div>
      <div v-if="reports.financial" class="col-md-5">
        <div class="card bg-dark p-4">
          <p class="text-muted">Valor Vendido: {{ reports.financial.sold | money }}</p>
          <p class="text-muted">Valor Autorizado: {{ reports.financial.authorized | money }}</p>
          <p class="text-muted">Aguardando Pagamento: {{ reports.financial.waiting | money }}</p>
          <p class="text-muted">Valor Recusado: {{ reports.financial.refused | money }}</p>
          <p class="text-muted">Valor Cancelado: {{ reports.financial.cancelled | money }}</p>
          <p class="text-muted">Ticket Médio: {{ reports.financial.average | money }}</p>
        </div>
      </div>
    </div>
    <DoughnutChartComponent v-if="reports.regions" :chart-data="reports.regions"></DoughnutChartComponent> -->
    <div class="card mb-4">
      <div class="card-body p-0">
        <div class="row">
          <div class="col-4 d-flex align-items-center">
            <p class="mb-0 fs-16 fw-600">Dashboard</p>
          </div>
          <div class="col-8 d-flex align-items-center justify-content-end gap-4">
            <svg @click="tab == 1 ? tab = 2 : tab = 1" class="pointer" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" id="Graph-Bar-Increase--Streamline-Core" height="20" width="20"><g id="graph-bar-increase--up-product-performance-increase-arrow-graph-business-chart"><path id="Vector" stroke="#92929d" stroke-linecap="round" stroke-linejoin="round" d="m1.23999 6.54006 11.50001 -5.23" stroke-width="1"></path><path id="Vector_2" stroke="#92929d" stroke-linecap="round" stroke-linejoin="round" d="m10.59 0.5 2.15 0.81 -0.8 2.15" stroke-width="1"></path><path id="Vector_3" stroke="#92929d" stroke-linecap="round" stroke-linejoin="round" d="M13.25 13.5h-2.5v-7c0 -0.13261 0.0527 -0.25979 0.1464 -0.35355C10.9902 6.05268 11.1174 6 11.25 6h1.5c0.1326 0 0.2598 0.05268 0.3536 0.14645 0.0937 0.09376 0.1464 0.22094 0.1464 0.35355v7Z" stroke-width="1"></path><path id="Vector_4" stroke="#92929d" stroke-linecap="round" stroke-linejoin="round" d="M8.25 13.5h-2.5l0 -5.5c0 -0.13261 0.05268 -0.25979 0.14645 -0.35355C5.99021 7.55268 6.11739 7.5 6.25 7.5h1.5c0.13261 0 0.25979 0.05268 0.35355 0.14645 0.09377 0.09376 0.14645 0.22094 0.14645 0.35355v5.5Z" stroke-width="1"></path><path id="Vector_5" stroke="#92929d" stroke-linecap="round" stroke-linejoin="round" d="M3.25 13.5H0.75l0 -4c0 -0.13261 0.052679 -0.25979 0.146447 -0.35355C0.990215 9.05268 1.11739 9 1.25 9h1.5c0.13261 0 0.25979 0.05268 0.35355 0.14645 0.09377 0.09376 0.14645 0.22094 0.14645 0.35355l0 4Z" stroke-width="1"></path></g></svg>
            <svg @click="openDashFilterModal()" class="pointer" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-1 -1 20 20" height="20" width="20" id="Filter-2--Streamline-Core.svg"><g id="Filter-2--Streamline-Core.svg"><path id="Vector" stroke="#92929d" stroke-linecap="round" stroke-linejoin="round" d="M17.357142857142858 0.6428571428571429H0.6428571428571429l6.428571428571429 9v7.714285714285715l3.8571428571428577 -2.5714285714285716v-5.142857142857143l6.428571428571429 -9Z" stroke-width="2"></path></g></svg>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="tab == 1">
      <div class="col-md-9">
        <div class="card mb-4">
          <p class="fs-16 fw-600 mb-0 pb-3">Total de pedidos</p>
          <LineChartComponent v-if="reports.orders_daily" :chart-data="reports.orders_daily" :options="options"></LineChartComponent>
        </div>
        <div class="card mb-4">
          <p class="fs-16 fw-600 mb-0 pb-3">Últimos Pedidos</p>
          <div class="table-responsive mt-1">
            <table class="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nome</th>
                  <th>Horário</th>
                  <th>Cidade-UF</th>
                  <th>Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="order in reports.orders" :key="order.id">
                  <td class="align-middle">
                    <router-link class="body-table c-black" :to="'./orders/' + order.id">
                      {{ order.id }}
                    </router-link>
                  </td>
                  <td class="align-middle">
                    <router-link class="body-table c-black" :to="'./orders/' + order.id">
                      {{ order.name.substr(0, 20)}}...
                    </router-link>
                  </td>
                  <td>
                    {{ order.created_at | datetime }}
                  </td>
                  <td class="align-middle">
                      {{ order.city }} - {{ order.state }}
                  </td>
                  <td>
                    {{ order.amount | money }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card mb-4">
          <p class="fs-16 fw-600 mb-0 pb-3">Erros de Integração</p>
          <div class="table-responsive mt-1">
            <table class="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Integração</th>
                  <th>Pedido</th>
                  <th>Status</th>
                  <th>Atualização</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="order_integration in reports.integrations.errors" :key="order_integration.id">
                  <td class="align-middle">
                    {{ order_integration.id }}
                  </td>
                  <td class="align-middle">
                    {{ order_integration.company_integration.integration.description }}
                  </td>
                  <td class="align-middle">
                    <router-link class="body-table c-black" :to="'./orders/' + order_integration.company_order_id">
                      {{ order_integration.company_order_id }}
                    </router-link>
                  </td>
                  <td>
                    Erro
                    <!-- <button class="btn mr-2 " data-toggle="modal" @click="openUpdateModal(integration)">
                      <i class="far fa-edit"></i>
                    </button>
                    <button class="btn" data-toggle="modal" @click="openDeleteModal(integration)">
                      <i class="fas fa-times text-danger"></i>
                    </button> -->
                  </td>
                  <td>
                    {{ order_integration.updated_at | datetime }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card mb-4">
          <p class="fs-16 fw-600 mb-0 pb-3">Valor vendido</p>
          <div class="d-flex align-items-center">
            <p class="fs-28 fw-600 mb-0 mr-3">{{ reports.financial.sold | money }}</p>
            <!-- <p class="fs-16 fw-600 mb-0 c-green">+2.5%
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9965 8.58307e-06C5.81079 -0.00090313 5.62477 0.0751123 5.49117 0.228018L0.831152 5.56135C0.588893 5.83861 0.617269 6.25977 0.894531 6.50203C1.17179 6.74429 1.59295 6.71591 1.83521 6.43865L5.33318 2.43526L5.33318 11.3333C5.33318 11.7015 5.63166 12 5.99985 12C6.36804 12 6.66651 11.7015 6.66651 11.3333L6.66651 2.44665L10.1651 6.43936C10.4078 6.71628 10.8289 6.74406 11.1059 6.50141C11.3828 6.25876 11.4106 5.83756 11.1679 5.56064L6.55155 0.292299C6.43161 0.11588 6.22926 0 5.99985 0C5.99873 0 5.99762 2.86102e-06 5.9965 8.58307e-06Z" fill="#3DD598"/>
              </svg>
            </p> -->
          </div>
          <!-- <p class="fs-14 fw-400 mb-0 c-grey">Comparação com o ano anterior</p> -->
        </div>
        <div class="card mb-4">
          <p class="fs-16 fw-600 mb-0 pb-3">Valor autorizado</p>
          <div class="d-flex align-items-center">
            <p class="fs-28 fw-600 mb-0 mr-3">{{ reports.financial.authorized | money }}</p>
            <!-- <p class="fs-16 fw-600 mb-0 c-green">+0.5%
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9965 8.58307e-06C5.81079 -0.00090313 5.62477 0.0751123 5.49117 0.228018L0.831152 5.56135C0.588893 5.83861 0.617269 6.25977 0.894531 6.50203C1.17179 6.74429 1.59295 6.71591 1.83521 6.43865L5.33318 2.43526L5.33318 11.3333C5.33318 11.7015 5.63166 12 5.99985 12C6.36804 12 6.66651 11.7015 6.66651 11.3333L6.66651 2.44665L10.1651 6.43936C10.4078 6.71628 10.8289 6.74406 11.1059 6.50141C11.3828 6.25876 11.4106 5.83756 11.1679 5.56064L6.55155 0.292299C6.43161 0.11588 6.22926 0 5.99985 0C5.99873 0 5.99762 2.86102e-06 5.9965 8.58307e-06Z" fill="#3DD598"/>
              </svg>
            </p> -->
          </div>
          <!-- <p class="fs-14 fw-400 mb-0 c-grey">Comparação com o ano anterior</p> -->
        </div>
        <div class="card mb-4">
          <p class="fs-16 fw-600 mb-0 pb-3">Ticket médio</p>
          <div class="d-flex align-items-center">
            <p class="fs-28 fw-600 mb-0 mr-3">{{ reports.financial.average | money }}</p>
          </div>
          <!-- <p class="fs-14 fw-400 mb-0 c-grey">Comparação com o ano anterior</p> -->
        </div>
        <div class="card mb-4">
          <p class="fs-16 fw-600 mb-0 pb-3">Aguardando pagamento</p>
          <div class="d-flex align-items-center">
            <p class="fs-28 fw-600 mb-0 mr-3">{{ reports.financial.waiting | money }}</p>
            <!-- <p class="fs-16 fw-600 mb-0 c-danger">-1.5%
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9965 8.58307e-06C5.81079 -0.00090313 5.62477 0.0751123 5.49117 0.228018L0.831152 5.56135C0.588893 5.83861 0.617269 6.25977 0.894531 6.50203C1.17179 6.74429 1.59295 6.71591 1.83521 6.43865L5.33318 2.43526L5.33318 11.3333C5.33318 11.7015 5.63166 12 5.99985 12C6.36804 12 6.66651 11.7015 6.66651 11.3333L6.66651 2.44665L10.1651 6.43936C10.4078 6.71628 10.8289 6.74406 11.1059 6.50141C11.3828 6.25876 11.4106 5.83756 11.1679 5.56064L6.55155 0.292299C6.43161 0.11588 6.22926 0 5.99985 0C5.99873 0 5.99762 2.86102e-06 5.9965 8.58307e-06Z" fill="#3DD598"/>
              </svg>
            </p> -->
          </div>
          <!-- <p class="fs-14 fw-400 mb-0 c-grey">Comparação com o ano anterior</p> -->
        </div>
        <div class="card mb-4">
          <p class="fs-16 fw-600 mb-0 pb-3">Valor recusado</p>
          <div class="d-flex align-items-center">
            <p class="fs-28 fw-600 mb-0 mr-3">{{ reports.financial.refused | money }}</p>
            <!-- <p class="fs-16 fw-600 mb-0 c-green">+2.5%
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9965 8.58307e-06C5.81079 -0.00090313 5.62477 0.0751123 5.49117 0.228018L0.831152 5.56135C0.588893 5.83861 0.617269 6.25977 0.894531 6.50203C1.17179 6.74429 1.59295 6.71591 1.83521 6.43865L5.33318 2.43526L5.33318 11.3333C5.33318 11.7015 5.63166 12 5.99985 12C6.36804 12 6.66651 11.7015 6.66651 11.3333L6.66651 2.44665L10.1651 6.43936C10.4078 6.71628 10.8289 6.74406 11.1059 6.50141C11.3828 6.25876 11.4106 5.83756 11.1679 5.56064L6.55155 0.292299C6.43161 0.11588 6.22926 0 5.99985 0C5.99873 0 5.99762 2.86102e-06 5.9965 8.58307e-06Z" fill="#3DD598"/>
              </svg>
            </p> -->
          </div>
          <!-- <p class="fs-14 fw-400 mb-0 c-grey">Comparação com o ano anterior</p> -->
        </div>
        <div class="card mb-4">
          <p class="fs-16 fw-600 mb-0 pb-3">Valor cancelado</p>
          <div class="d-flex align-items-center">
            <p class="fs-28 fw-600 mb-0 mr-3">{{ reports.financial.cancelled | money }}</p>
          </div>
          <!-- <p class="fs-14 fw-400 mb-0 c-grey">Comparação com o ano anterior</p> -->
        </div>
      </div>
    </div>
    <div class="row" v-if="tab == 2">
      <div class="col-12">
        <div class="d-flex">
          <div class="d-flex flex-column border-end bg-white min-w-category">
            <div class="d-flex bg-secondary text-white sticky-top">
              <div class="text-center fw-bold px-3 py-2 border-end">
                <p class="mb-0">Relatório</p>
              </div>
            </div>
            <div v-for="category in reports.analytic_categories" :key="category.id" class="d-flex">
              <div class="h-100 w-100 fw-bold px-3 py-1 border-bottom bg-light cs-width">
                {{ category.name }}
              </div>
              <div class="d-flex flex-column w-100 min-w-subcategory">
                <div
                  v-for="subcategory in category.subcategories"
                  :key="subcategory.id"
                  class="px-2 py-2 border-bottom "
                >
                  <p class="mb-0 subcategory-title pointer" :title="subcategory.name">
                    {{ subcategory.name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-grow-1 overflow-auto">
            <div class="d-flex flex-column h-100" style="min-width: max-content;">
              <!-- Cabeçalho dos meses -->
              <div class="d-flex bg-secondary text-white sticky-top">
                <div
                  v-for="header in reports.month_headers"
                  :key="header"
                  class="text-center fw-bold px-3 py-2 border-end text-nowrap content-width"
                >
                  {{ header }}
                </div>
              </div>
              <div>
                <div v-for="(category, cindex) in reports.analytic_categories" :key="category.id">
                  <div
                    v-for="subcategory in category.subcategories"
                    :key="subcategory.id"
                    class="d-flex ws-nowrap"
                  >
                    <div
                      v-for="header in reports.month_headers"
                      :key="header"
                      class="px-2 py-2 d-flex align-items-center justify-content-center gap-2 border-end border-bottom text-nowrap content-width category"
                    >
                      <span v-if="editingField !== `${subcategory.id}-${header}`">
                        {{ getMonthValue(subcategory.months, header) }}
                      </span>
                      <input v-else type="text" class="form-control" :value="getMonthValue(subcategory.months, header)" @blur="updateMonthValue(subcategory, header, $event.target.value)"/>
                      <button
                        v-if="editingField !== `${subcategory.id}-${header}` && cindex > 0"
                        @click="editSubCategory(subcategory.id, header)"
                        type="button"
                        class="pointer btn btn-none edit-category p-0 m-0"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" class="bi bi-pencil-square" viewBox="0 0 16 16" id="Pencil-Square--Streamline-Bootstrap" height="15" width="15"><path d="M15.502 1.94a0.5 0.5 0 0 1 0 0.706L14.459 3.69l-2 -2L13.502 0.646a0.5 0.5 0 0 1 0.707 0l1.293 1.293zm-1.75 2.456 -2 -2L4.939 9.21a0.5 0.5 0 0 0 -0.121 0.196l-0.805 2.414a0.25 0.25 0 0 0 0.316 0.316l2.414 -0.805a0.5 0.5 0 0 0 0.196 -0.12l6.813 -6.814z" stroke-width="1"></path><path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5 -1.5v-6a0.5 0.5 0 0 0 -1 0v6a0.5 0.5 0 0 1 -0.5 0.5h-11a0.5 0.5 0 0 1 -0.5 -0.5v-11a0.5 0.5 0 0 1 0.5 -0.5H9a0.5 0.5 0 0 0 0 -1H2.5A1.5 1.5 0 0 0 1 2.5z" stroke-width="1"></path></svg>
                      </button>

                      <button
                        v-if="editingField === `${subcategory.id}-${header}`"
                        @click="updateMonthValue(subcategory, header, tempValue)"
                        type="button"
                        class="btn btn-none p-0 m-0"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#12d302" class="bi bi-check2" viewBox="0 0 16 16" id="Check2--Streamline-Bootstrap" height="15" width="15"><path d="M13.854 3.646a0.5 0.5 0 0 1 0 0.708l-7 7a0.5 0.5 0 0 1 -0.708 0l-3.5 -3.5a0.5 0.5 0 1 1 0.708 -0.708L6.5 10.293l6.646 -6.647a0.5 0.5 0 0 1 0.708 0" stroke-width="1"></path></svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade mt-5" id="openDashboardFilterModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog " role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Selecione o intervalo de data</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" >
            <div class="row">
              <div class="col">
                <label for="from" class="form-control-label">De:</label>
                <input type="date" id="from" v-model="reports.from" class="form-control">
              </div>
              <div class="col">
                <label for="to" class="form-control-label">Até</label>
                <input type="date" id="to" v-model="reports.to" class="form-control">
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-danger" data-dismiss="modal">Fechar</button>
            <button class="btn btn-secondary px-4" @click="index({ types: ['orders-daily', 'orders-financial', 'integrations-errors', 'last-order'], from: reports.from, to: reports.to })">Buscar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
// import OrderComponent from '../components/layout/BarChart.vue'
// import DoughnutChartComponent from './chart/DoughnutChartComponent'
import LineChartComponent from './chart/LineChartComponent'

export default {
  name: 'Home',
  components: {
    // DoughnutChartComponent,
    LineChartComponent
    // OrderComponent
  },

  computed: mapState({
    reports: state => state.reports.data
  }),

  data () {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false
      },
      from: null,
      to: null,
      tab: 1,
      editingField: null
    }
  },

  methods: {
    ...mapActions('reports', [
      'index',
      'analyticCategories',
      'updateReportMonth'
    ]),

    getRandomInt () {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },

    openDashFilterModal () {
      $('#openDashboardFilterModal').modal('show')
    },

    getMonthValue (monthsArray, header) {
      const found = monthsArray.find(m =>
        this.formatDateToMonthHeader(m.date).toLowerCase() === header.toLowerCase()
      )

      return found ? found.value : 0
    },

    formatDateToMonthHeader (dateStr) {
      const dateParts = dateStr.split('-')
      const year = parseInt(dateParts[0])
      const month = parseInt(dateParts[1]) - 1
      const day = parseInt(dateParts[2])

      const date = new Date(Date.UTC(year, month, day))
      const monthName = date.toLocaleDateString('pt-BR', { month: 'short', timeZone: 'UTC' }).replace('.', '')
      const shortYear = date.getUTCFullYear().toString().slice(2)

      return `${monthName}-${shortYear}`
    },

    editSubCategory (subcategoryId, header) {
      this.editingField = `${subcategoryId}-${header}`
    },

    updateMonthValue (subcategory, header, newValue) {
      const item = subcategory.months.find(m =>
        this.formatDateToMonthHeader(m.date).toLowerCase() === header.toLowerCase()
      )

      if (item) {
        item.value = newValue
      }

      this.updateReportMonth(item)

      this.editingField = null
      this.tempValue = ''
    }
  },

  mounted () {
    this.index({
      types: ['orders-daily', 'orders-financial', 'integrations-errors', 'last-order'],
      from: null,
      to: null
    })

    this.analyticCategories()
  }

}
</script>
<style scoped>
.cs-width {
  width: 150px;
}
.min-w-category {
  min-width: 350px;
}
.min-w-subcategory {
  min-width: 200px;
}
.content-width {
  width: 150px;
}
.edit-category {
  display: none;
}
.category:hover .edit-category {
  display: block;
}
.ws-nowrap {
  white-space: nowrap;
}
button:focus {
  outline: none;
  box-shadow: none;
}
.subcategory-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
